export const shouldShowFileUploadTop = (contentType: any): boolean => {
  return contentType?.usesFilesProcessor === true && contentType != null;
};

export const shouldShowFileUploadBottom = (contentType: any): boolean => {
  return contentType?.usesFilesProcessor !== true && contentType != null;
};

export const shouldShowFileMetadataTable = (needsToRenderFilesInTable: boolean, fileCount: number): boolean => {
  return needsToRenderFilesInTable && fileCount > 0;
};
